const EFFECT_TO_GROUP = {
  increase: 'increase_contributors',
  moderate: 'moderate_contributors',
  decrease: 'decrease_contributors',
}

const PERCENTILE_LEVEL_TO_SCORE_LEVEL = {
  high: 'high score',
  moderate: 'average score',
  low: 'low score',
}

const emptyContributors = () => ({
  increase_contributors: [],
  moderate_contributors: [],
  decrease_contributors: [],
})

export const buildContributorsForArea = (areaKey, contributionSignificance) => {
  if (!areaKey || !contributionSignificance) {
    return emptyContributors()
  }

  const { facet_codes, percentile_levels, weights, effects } =
    contributionSignificance
  const talentWeights = weights?.[areaKey]
  const talentEffects = effects?.[areaKey]

  if (
    !facet_codes?.length ||
    !talentWeights?.length ||
    !talentEffects?.length ||
    !percentile_levels?.length
  ) {
    return emptyContributors()
  }

  const groups = emptyContributors()

  facet_codes.forEach((facet_code, index) => {
    const groupKey = EFFECT_TO_GROUP[talentEffects[index]]
    if (!groupKey) {
      return
    }

    const weight = talentWeights[index]
    groups[groupKey].push({
      facet_code,
      direction:
        weight >= 0 ? 'high score is good' : 'low score is good',
      level:
        PERCENTILE_LEVEL_TO_SCORE_LEVEL[percentile_levels[index]] ??
        'average score',
      sortWeight: Math.abs(weight),
    })
  })

  Object.keys(groups).forEach(groupKey => {
    groups[groupKey].sort((left, right) => right.sortWeight - left.sortWeight)
    groups[groupKey] = groups[groupKey].map(
      ({ facet_code, direction, level }) => ({
        facet_code,
        direction,
        level,
      }),
    )
  })

  return groups
}
